(() => {
  function updateVariant(card, option) {
    if (!card || !option) return;

    const image = card.querySelector('[data-pc-image]');
    const current = card.querySelector('[data-pc-current]');
    const compare = card.querySelector('[data-pc-compare]');
    const price = card.querySelector('[data-pc-price]');
    const links = card.querySelectorAll('[data-pc-link]');
    const atcId = card.querySelector('[data-pc-atc-id]');
    const buy = card.querySelector('[data-pc-buy]');
    const saleBadge = card.querySelector('[data-pc-sale-badge]');
    const soldBadge = card.querySelector('[data-pc-sold-badge]');
    const isSale = option.dataset.sale === 'true';
    const isAvailable = option.dataset.available === 'true';

    if (image && option.dataset.image) image.src = option.dataset.image;
    if (current) current.textContent = option.dataset.price || '';

    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !isSale;
    } else if (isSale && price) {
      const strike = document.createElement('s');
      strike.dataset.pcCompare = '';
      strike.textContent = option.dataset.compare || '';
      price.prepend(strike);
    }

    price?.classList.toggle('is-sale', isSale);
    if (saleBadge) saleBadge.hidden = !isSale;
    if (soldBadge) soldBadge.hidden = isAvailable;

    links.forEach((link) => link.href = option.dataset.url || card.dataset.url);

    if (atcId) atcId.value = option.value;
    if (buy) {
      buy.href = option.dataset.url || card.dataset.url;
      buy.textContent = isAvailable ? buy.dataset.defaultLabel || buy.textContent : 'View product';
    }

    card.classList.toggle('plug-card--sold-out', !isAvailable);
  }

  function initVariants(section) {
    section.querySelectorAll('[data-pc-card]').forEach((card) => {
      const select = card.querySelector('[data-pc-variant-select]');

      if (select) {
        select.addEventListener('change', () => {
          updateVariant(card, select.options[select.selectedIndex]);
        });
      }

      card.querySelectorAll('[data-pc-variant]').forEach((input) => {
        input.addEventListener('change', () => updateVariant(card, input));
      });
    });
  }

  function initSort(section) {
    const sort = section.querySelector('[data-pc-sort]');
    sort?.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  function initFilters(section) {
    const filters = section.querySelector('[data-pc-filters]');
    const backdrop = section.querySelector('.plug-col__drawer-backdrop');

    const open = () => {
      if (!filters) return;
      filters.classList.add('is-open');
      if (backdrop) backdrop.hidden = false;
      document.body.classList.add('plug-col-lock');
    };

    const close = () => {
      filters?.classList.remove('is-open');
      if (backdrop) backdrop.hidden = true;
      document.body.classList.remove('plug-col-lock');
    };

    section.querySelector('[data-pc-filter-open]')?.addEventListener('click', open);
    section.querySelectorAll('[data-pc-filter-close]').forEach((button) => {
      button.addEventListener('click', close);
    });
  }

  function initViews(section) {
    const grid = section.querySelector('[data-pc-grid]');
    const buttons = section.querySelectorAll('[data-pc-view]');
    if (!grid) return;

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const list = button.dataset.pcView === 'list';
        grid.classList.toggle('is-list', list);
        buttons.forEach((item) => item.classList.toggle('is-active', item === button));
      });
    });
  }

  function initQuick(section) {
    const modal = section.querySelector('[data-pc-quick]');
    if (!modal) return;

    const image = modal.querySelector('[data-pc-quick-image]');
    const title = modal.querySelector('[data-pc-quick-title]');
    const variants = modal.querySelector('[data-pc-quick-variants]');
    const price = modal.querySelector('[data-pc-quick-price]');
    const link = modal.querySelector('[data-pc-quick-link]');
    let returnFocus = null;

    const close = () => {
      modal.hidden = true;
      document.body.classList.remove('plug-col-lock');
      returnFocus?.focus?.();
    };

    const render = (input) => {
      const sale = input?.dataset.sale === 'true';
      if (price) {
        price.classList.toggle('is-sale', sale);
        price.innerHTML = `${sale ? `<s>${input.dataset.compare || ''}</s>` : ''}<strong>${input?.dataset.price || ''}</strong>`;
      }
      if (image && input?.dataset.image) image.src = input.dataset.image;
      if (link) link.href = input?.dataset.url || '#';
    };

    const open = (button) => {
      const card = button.closest('[data-pc-card]');
      if (!card) return;

      returnFocus = button;
      const select = card.querySelector('[data-pc-variant-select]');
      const selected =
        select?.options[select.selectedIndex] ||
        card.querySelector('[data-pc-variant]:checked') ||
        card.querySelector('[data-pc-variant]');
      const cardImage = card.querySelector('[data-pc-image]');

      if (title) title.textContent = card.dataset.title || '';
      if (image) {
        image.src = selected?.dataset.image || cardImage?.src || '';
        image.alt = card.dataset.title || '';
      }
      if (link) link.href = selected?.dataset.url || card.dataset.url || '#';

      if (variants) {
        variants.innerHTML = '';
        const sourceSelect = card.querySelector('[data-pc-variant-select]');
        const sourceRadios = card.querySelector('.plug-card__variants');

        if (sourceSelect) {
          const label = document.createElement('label');
          label.className = 'plug-card__variant-select';
          label.innerHTML = '<span>Choose option</span>';

          const clone = sourceSelect.cloneNode(true);
          clone.addEventListener('change', () => {
            render(clone.options[clone.selectedIndex]);
          });

          label.appendChild(clone);
          variants.appendChild(label);
          variants.hidden = false;
        } else if (sourceRadios) {
          const clone = sourceRadios.cloneNode(true);
          const groupName = `pc-qv-${Date.now()}`;

          clone.querySelectorAll('input').forEach((input) => {
            input.name = groupName;
            input.addEventListener('change', () => render(input));
          });

          variants.appendChild(clone);
          variants.hidden = false;
        } else {
          variants.hidden = true;
        }
      }

      if (selected) {
        render(selected);
      } else if (price) {
        const sourcePrice = card.querySelector('[data-pc-price]');
        price.innerHTML = sourcePrice?.innerHTML || '';
        price.classList.toggle('is-sale', sourcePrice?.classList.contains('is-sale'));
      }

      modal.hidden = false;
      document.body.classList.add('plug-col-lock');
      modal.querySelector('.plug-col__quick-close')?.focus();
    };

    section.querySelectorAll('[data-pc-quick-open]').forEach((button) => {
      button.addEventListener('click', () => open(button));
    });

    modal.querySelectorAll('[data-pc-quick-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initSection(section) {
    initVariants(section);
    initSort(section);
    initFilters(section);
    initViews(section);
    initQuick(section);
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-plug-collection]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();